import script from "./SurveyBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyBoard.vue?vue&type=script&setup=true&lang=js"

import "./SurveyBoard.vue?vue&type=style&index=0&id=3db2d08e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db2d08e"]])

export default __exports__